import React, { useState } from "react";
import { Modal } from "antd";
import toast from "react-hot-toast";
import adminService from "../../services/userApprovalService";

const DeleteUserModal = ({ open, setOpen, id, setUpdate }) => {
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [modalText, setModalText] = useState(
    "Are you sure you want to delete this user?"
  );

  const handleCancel = () => {
    console.log("Clicked cancel button");
    setOpen(false);
  };

  const handleDelete = async () => {
    setConfirmLoading(true);
    try {
      const response = await adminService.deleteUser(id);
      if (response.success) {
        toast.success("User Deleted");
        setConfirmLoading(false);
        setOpen(false);
        setUpdate(true);
      }
    } catch(error) {
        console.log(error);

      toast.error("Failed to delete user");
    }
  };

  return (
    <>
      <Modal
        title="PDF Deletion"
        open={open}
        onOk={handleDelete}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
      >
        <p>{modalText}</p>
      </Modal>
    </>
  );
};

export default DeleteUserModal;
